import type { Sequence } from "../types/Sequence"

import { Zip } from "./Zip"

/**
 * Creates a record object from separate key and value sequences.
 * Zips keys and values together into an object.
 *
 * @param keys - Sequence of string keys
 * @param values - Sequence of values
 * @returns Record object mapping keys to values
 *
 * @example
 * ```ts
 * import { RecordCreate } from "@pdfking/tfunc"
 *
 * const keys = ["name", "age", "city"]
 * const values = ["John", 30, "NYC"]
 * const record = RecordCreate(keys, values)
 * // { name: "John", age: 30, city: "NYC" }
 * ```
 */
export const RecordCreate = <T>(
  keys: Sequence<string>,
  values: Sequence<T>
): Record<string, T> => Object.fromEntries(Zip(keys, values))
